// Utils
import { twMerge } from 'tailwind-merge';

export const Layout: React.FC<React.ComponentProps<'div'>> = ({
  className,
  ...props
}) => (
  <div
    {...props}
    className={twMerge(
      'container mx-auto grid grid-cols-12 gap-x-6 px-4',
      className
    )}
  />
);
